const content: { [key: string]: any } = {
  sessionList: 'Sessions',
};

export default content;
